import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";

export default class DeleteDocumentTypeFromOrganisationInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.resource = deleteResource;
  }

  async execute(path: string, documentTypeId: number) {
    return this.resource.execute(path, documentTypeId);
  }
}
